import appendCDN from "../utils/append_cdn_link"

const Loading = ({ type, ...rest}) => {

  let src = '/img/'

  switch (type) {
    case 'circle':
      src += 'loading-circle.svg'
      break
    default:
      src += 'loading.svg'
  }

  return <object {...rest} data={appendCDN(src)} />
}

export default Loading
